import React, { FC, memo, useState, useContext, useCallback, useEffect } from 'react';
import { ResultContext } from '../../context/result-context';

import Content from '../../components/content';
import Button from '../../components/button';

import {answerContent} from './answer-content';
import './answer.scss';
import AnsweSuccess from './answer-success.svg';
import AnswerFail from './answer-fail.svg';

interface AnswerProps {
  question: number;
  current: number;
  isRight: boolean;
  onClick: () => void;
}

let timerId: number;

const Answer: FC<AnswerProps> = memo(({
  question,
  current,
  isRight = false,
  onClick
}) => {
  const { currentResult } = useContext(ResultContext);
  const [lastResult, setLastResult] = useState(isRight ? currentResult : (currentResult + 5));


  const animationResult = useCallback(() => {
    timerId = window.setInterval(() => {
      if (lastResult <= currentResult) {
        clearInterval(timerId);
      } else {
        setLastResult(lastResult - 1);
      }
    }, 80);
  }, [lastResult, currentResult]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    animationResult();

    return () => {
      clearInterval(timerId);
    };
  }, [animationResult]);

  return (
    <div className="answer">
      <Content className={`${isRight ? '-blue' : '-red'}`} isInner={true}>
        <div className="answer__header">
          <div className="answer__title">Интернет-броня:</div>
          <div className={`answer__result ${isRight ? '-success' : '-fail'}`}>
            <div className="answer__resultbody">
            {lastResult} из 50
            { isRight === false &&
              <span>-5</span>
            }
            </div>
          </div>
        </div>
        <img src={isRight ? AnsweSuccess : AnswerFail} alt="" className="answer__img" />
        <p className="answer__text" dangerouslySetInnerHTML={{ __html: answerContent[question].anwers[current].text }}></p>
        { answerContent[question].anwers[current].comment &&
          <p className="answer__comment" dangerouslySetInnerHTML={{ __html: answerContent[question].anwers[current].comment }}></p>
        }
        <Button onClick={onClick}>Дальше</Button>
      </Content>
	  </div>
  );
});

export default Answer;
